// ONE "All projects" option builder for the EOI and Deals dropdowns (owner task
// 2026-10-29). Both pages used to walk their rows, de-dupe on trim+lowercase and
// emit the FIRST raw spelling as the option — so a project typed with a double
// space, or first met in its odd capitalisation, showed up twice or under its
// worst spelling. This folds every stored spelling through the SAME key the
// table matcher (selMatchName → normProjectFE: trim + collapse whitespace,
// compared case-insensitively) uses, so one canonical entry per project, and
// selecting it still matches every variant in the table.
//
// Projects are case- and whitespace-folded ONLY — never variant-merged. That is
// the server's rule for normalizeProjectName ("Zed 2" is not "Zed"); the campaign
// variant merge (trailing "- Copy" / number / month) does not apply to projects.
//
// `fold` is passed in (normProjectFE from App.js) so this file never grows a
// second copy of the fold. Label and value are the MOST FREQUENT stored spelling
// of the key; ties break by code-point order, the server's own rule in
// /api/filter-options' collapse() — "Palm Hills" beats "palm hills", and the label
// is STABLE instead of following document order. Value lowercases to the key,
// which is what selMatchName compares against. Sorted A→Z. `count` rides on each
// option for a caller that wants to show it; the label stays the bare name.
export function canonicalProjectOptions(rows, getProject, fold) {
  var byKey = {}, order = [];
  (rows || []).forEach(function (row) {
    var raw = String((getProject ? getProject(row) : row) || "").trim();
    if (!raw) return;
    var base = fold(raw), key = base.toLowerCase();
    if (!key) return;
    var e = byKey[key];
    if (!e) { e = byKey[key] = { count: 0, spellings: {}, first: base }; order.push(key); }
    e.count++;
    e.spellings[base] = (e.spellings[base] || 0) + 1;
  });
  return order.map(function (key) {
    var e = byKey[key];
    var best = Object.keys(e.spellings).sort(function (x, y) {
      return (e.spellings[y] - e.spellings[x]) || (x < y ? -1 : x > y ? 1 : 0);
    })[0];
    return { value: best, label: best, count: e.count };
  }).sort(function (a, b) { return String(a.label).localeCompare(String(b.label)); });
}
